import React from "react";
import "../../assets/styles/components/_login.scss";
import logo from '../../assets/images/brand/Tensolite-Isologotipo-blanco.png'
import useForm from "../../hooks/useForm";
import useLogin from "../../hooks/useLogin";
import toast from 'react-hot-toast';
import { ROLES_PGI } from "../../helpers/constants";


const Login = () => {

  const { values, handleInputChange, emailError, passwordError, errorEmailInput, errorPasswordInput, reset } = useForm({
    email: "",
    password: "",
  });

  const { handleSubmit } = useLogin();

  const MostrarMensajeError = (event) => {
    toast.error("Email y/o contraseña incorrectos")
    event.preventDefault()
  } 

  const VerificarCampos = (event, values) => {

    (!emailError) && (!passwordError) ? handleSubmit(event, values,"/pgi", ROLES_PGI) : MostrarMensajeError(event)
  };

  return (
    <>
      <form className="container login__card-form" onSubmit={(event) => VerificarCampos(event, values)}>
      <div className='logo-login'>
                            <img src={logo} alt="Logo Tensolite" className='logo' />
                        </div>
        <div className="flex-row">
          <input
            type="text"
            id="email"
            name="email"
            className={`lf--input ${errorEmailInput ? "input-error" : ""} `}
            placeholder="Email"
            value={values.email}
            onChange={handleInputChange}
          />
        </div>
        <div className="flex-row">
          <input
            type="password"
            id="password"
            name="password"
            className={`lf--input ${errorPasswordInput ? "input-error" : ""} `}
            placeholder="Contraseña"
            value={values.password}
            onChange={handleInputChange}
          />
        </div>
        <input type="submit" className="button--submit" value="INGRESAR" />
        <label className="super_label_recover">
          <a href="/clientes/olvide-password">¿Olvidaste tu contraseña?</a>
        </label>
      </form>
    </>
  );
};

export default Login;
